import { IToolData } from "common/records/Tool";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_TOOL = "@tools/RECEIVE_TOOL";
export const RECEIVE_TOOLS = "@tools/RECEIVE_TOOLS";
export const REMOVE_TOOL = "@tools/REMOVE_TOOL";
export const ADD_TOOL_IMAGE = "@tools/ADD_TOOL_IMAGE";
export const REMOVE_TOOL_IMAGE = "@tools/REMOVE_TOOL_IMAGE";
export const RESET_TOOL = "@tools/RESET_TOOL";

export const ToolActions = {
  receiveTool: (tool: Partial<IToolData>) => createAction(RECEIVE_TOOL, tool),
  receiveTools: (tools: Partial<IToolData>[]) => createAction(RECEIVE_TOOLS, { tools: tools }),
  removeTool: (toolId: number) => createAction(REMOVE_TOOL, toolId),
  addToolImage: (toolId: number, imageFile: any) => createAction(ADD_TOOL_IMAGE, { toolId, imageFile }),
  removeToolImage: (toolId: number) => createAction(REMOVE_TOOL_IMAGE, { toolId }),
  resetTool: (toolId: number) => createAction(RESET_TOOL, toolId),
};

export type ToolActions = ActionsUnion<typeof ToolActions>;
